import React, {useEffect, useState, useRef} from 'react';
import Comment from './Comment';
import InfiniteScroll from 'react-infinite-scroll-component';
import Loader from '../loader/Loader';
import uniqid from 'uniqid';
import {getAllCommentsPaginated} from '../../services/commentsService';


const CommentsList = (props) => {
  const {activeRisk, commentAdded, id} = props;
  const [hasMore, setHasMore] = useState(true);
  const [pageNumber, setPageNumber] = useState(0);
  const [comments, setComments] = useState([]);
  const [isLoadingPage, setIsLoadingPage] = useState(true);
  const listId = uniqid();
  const unmounted = useRef(false);

  let comment = {};

  const fetchData = () => {
    setHasMore(true);
    setPageNumber(0);

    getAllCommentsPaginated(id,activeRisk, 0)
      .then((r) => {
        if (!unmounted.current) {
          onFetchSuccess(r);
        }
      })
      .catch((r) => {
        if (!unmounted.current) {
          onFetchFailed(r);
        }
      });
  };

  const onFetchSuccess = (r) => {
    if (r.data.length !== 0) {
      setComments(r.data);
      setIsLoadingPage(false);
      setPageNumber(1);
    } else {
      setComments(r.data);
      setIsLoadingPage(false);
      setHasMore(false);
    }
  };

  const onFetchFailed = (r) => {
    setIsLoadingPage(false);
    // Swal.fire({
    //   text: `${t('message.errorApi')}`,
    //   icon: 'error',
    //   confirmButtonText: 'Ok',
    // });
  };

  const onFetchMoreSuccess = (r) => {
    if (r.data.length !== 0) {
      const newData = comments;
      r.data.map((item) => newData.push(item));
      setComments(newData);
      setPageNumber(pageNumber + 1);
    } else {
      setHasMore(false);
    }
  };

  const fetchMoreData = (id) => {
    if (!unmounted.current) {
      getAllCommentsPaginated(activeRisk.id, pageNumber)
        .then((r) => onFetchMoreSuccess(r))
        .catch((r) => onFetchFailed(r));
    }
  };

  useEffect(() => {
    fetchData();
  }, [commentAdded, activeRisk]);

  useEffect(() => {
    return () => {
      unmounted.current = true;
    };
  }, []);

  return (
    <div className="document-comments-list" id={listId}>
      {isLoadingPage && <Loader />}
      <InfiniteScroll
        dataLength={comments.length}
        next={fetchMoreData}
        hasMore={false}
        scrollableTarget={listId}
        scrollThreshold={0.7}
        loader={<Loader />}
      >
        {comments.map((comment) => {
          return <Comment comment={comment} key={uniqid()} />;
        })}
      </InfiniteScroll>
    </div>
  );
};

export default CommentsList;
